import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { FRENTISTA, GPP, GFE, GPPE, GPPEM } from '~/constants/perfil';

import { isEmpty } from 'lodash';

import { Spinner } from '~/components';
import {
  Select,
  Input,
  Checkbox,
  RadioGroup,
  Autocomplete,
  InputText,
} from '~/components/Form';
import { t, validCharacters, validarCPF, validSomenteNumeros, validCharactersComAcentuados } from '~/helpers';
import {
  storeFrentista,
  updateFrentista,
} from '~/store/modules/frentista/actions';


import api from '~/services/api';
import { toast } from 'react-toastify';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const { loading, find, params } = useSelector((state) => state.frentista);

  const initials = create ? data : { ...find, ...data };

  const [valuePosto, setValuePosto] = React.useState(null);

  const [inputValuePosto, setInputValuePosto] = React.useState('');

  // controle lista
  const useStyles = makeStyles((theme) => ({
    root: {
      margin: 'auto',
    },
    paper: {
      width: 200,
      height: 230,
      overflow: 'auto',
    },
    button: {
      margin: theme.spacing(0.5, 0),
    },
  }));

  function not(a, b) {
    return a.filter((value) => b.indexOf(value) === -1);
  }

  function intersection(a, b) {
    return a.filter((value) => b.indexOf(value) !== -1);
  }

  const [snLA, setSnLA] = React.useState(false);
  const [snRC, setSnRC] = React.useState(false);
  const [snOT, setSnOT] = React.useState(false);

  const [postos, setPostos] = React.useState([]);

  const classes = useStyles();
  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState([]);
  const [right, setRight] = React.useState([]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const { profile } = useSelector((state) => state.user);

  const [isGPP, setIsGPP] = React.useState(false);

  const [isGFE, setIsGFE] = React.useState(false);

  const [isGPPE, setIsGPPE] = React.useState(false);

  const [isGPPEM, setIsGPPEM] = React.useState(false);

  const [codigoPosto, setCodigoPosto] = React.useState('');

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };

  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };

  const customList = (items) => (
    <Paper className={classes.paper}>
      <List dense component="div" role="list">
        {items.map((value) => {
          const labelId = value.poco_codigo;

          return (
            <ListItem
              key={value}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                  name={labelId}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value.poco_desc_abrev} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Paper>
  );

  // fim controle

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        usua_login: Yup.string()
          .matches(/^[0-9]+$/, 'Este campo deve conter um valor inteiro')
          .required('Este campo deve conter um valor inteiro')
          .max(6, t('s.geral.validacao.tamanhomaximo').replace('%s', 6)),
        usua_nome: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(100, t('s.geral.validacao.tamanhomaximo').replace('%s', 100))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharactersComAcentuados(value);
            }
          ),
        usua_cpf: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(11, t('s.geral.validacao.tamanhomaximo').replace('%s', 11))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            function (value) {
              return validCharacters(value);
            }
          )
          .test('invalid format', t('CPF incorreto'), function (value) {
            return validarCPF(value);
          }),
        usua_senha: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(4, t('s.geral.validacao.tamanhomaximo').replace('%s', 4))
          .min(4, t('s.geral.validacao.tamanhominimo').replace('%s', 4))
          .test(
            'characters-invalid',
            'Somente números são aceitos',
            function (value) {
              return validSomenteNumeros(value);
            }
          ),
        usua_status: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(1, t('s.geral.validacao.tamanhomaximo').replace('%s', 1)),
        usua_parametro5: (isGPP || isGFE || isGPPE || isGPPEM)
          ? Yup.string().nullable()
          : Yup.number().required(t('s.geral.validacao.campoobrigatorio')),
        usua_parametro7: (isGPP || isGFE || isGPPE || isGPPEM)
          ? Yup.string().nullable()
          : Yup.number().required(t('s.geral.validacao.campoobrigatorio')),
        poco_codigo: (isGPP)
          ? Yup.string().nullable()
          : Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
        ,
      });


      await schema.validate({ ...param, poco_codigo: valuePosto, usua_nome: param.usua_nome ? param.usua_nome.trim() : param.usua_nome }, {
        abortEarly: false,
      });

      let codigos = [];

      if (isGPP) {
        codigos.push(codigoPosto);
      } else if ((isGFE || isGPPE || isGPPEM)) {
        codigos.push(valuePosto);
      } else {
        right.map(function (item) {
          codigos.push(item.poco_codigo);
        });
      }

      const objSend = {
        // ...initials,
        //...param,
        usua_login: param.usua_login,
        usua_nome: param.usua_nome,
        usua_cpf: param.usua_cpf,
        usua_senha: param.usua_senha,
        usua_parametro1: snLA ? '1' : '0',
        usua_parametro2: snRC ? '1' : '0',
        usua_parametro3: snOT ? '1' : '0',
        usua_parametro4: '0',
        usua_parametro5: (isGPP || isGFE || isGPPE || isGPPEM) ? '0' : param.usua_parametro5,
        usua_parametro6: '0',
        usua_parametro7: (isGPP || isGFE || isGPPE || isGPPEM) ? '0' : param.usua_parametro7,
        usua_parametro8: '0',
        usua_cont_senha_errada: 0,
        usua_tipo: 'F',
        perf_codigo: FRENTISTA,
        poco_codigo: isGPP ? codigoPosto : valuePosto,
        orga_codigo: null,
        usua_email: null,
        usua_recebe_email: 'N',
        usua_consulta_controla_agenda: 0,
        usua_aprova_pre_faturamento: 'N',
        fadi_codigo: 0,
        perf_tipo: 0,
        usua_status: param.usua_status,
        usuarioPosto: codigos,
        usuarioLogadoPostoSelecionados: null,
        usuarioLogadoPostoDisponiveis: null,
      };

      if (create) {
        await dispatch(storeFrentista(objSend, params));
      } else {
        await dispatch(updateFrentista(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      } else {
        throw err;
      }
    }
  }

  async function handleCarregaPostos() {
    const response = await api.get('postosporusuario', {
      params: {
        orderfield: 'poco_desc_abrev',
        pagesize: 99999,
      },
    });

    if (!isEmpty(response.data) && !isEmpty(response.data.items)) {
      setLeft(response.data.items);
      setRight([]);
    } else {
      setLeft([]);
      setRight([]);
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GPP) {
        setIsGPP(true);
        setCodigoPosto(profile.glousuariopostocodigo);
      }

      if (profile.glousuariotipo === GFE) {
        setIsGFE(true);
      }

      if (profile.glousuariotipo === GPPE) {
        setIsGPPE(true);
      }

      if (profile.glousuariotipo === GPPEM) {
        setIsGPPEM(true);
      }

    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  useEffect(() => {
    if (!loading) {
      if (create) {
        handleCarregaPostos();
      } else {
        const {
          usua_parametro1,
          usua_parametro2,
          usua_parametro3,
          usuarioPosto,
          usuarioLogadoPostoSelecionados,
          usuarioLogadoPostoDisponiveis,
        } = find;

        if (usua_parametro1 && usua_parametro1 === '1') {
          setSnLA(true);
        }

        if (usua_parametro2 && usua_parametro2 === '1') {
          setSnRC(true);
        }

        if (usua_parametro3 && usua_parametro3 === '1') {
          setSnOT(true);
        }

        if (usuarioPosto) {
          setPostos(usuarioPosto);
        }

        if (usuarioLogadoPostoDisponiveis) {
          setLeft(usuarioLogadoPostoDisponiveis);
        }

        if (usuarioLogadoPostoSelecionados) {
          setRight(usuarioLogadoPostoSelecionados);
        }
      }
    }
  }, [find]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form
          ref={reference}
          initialData={{
            usua_parametro5: '0',
            usua_parametro7: '0',
            ...initials,
          }}
          onSubmit={handleSubmit}
        >
          {create ?
            <InputText
              name="usua_login"
              label="Login"
              type="number"
              disabled={!create}
              mask="999999"
              placeholder=""
            /> :
            <Input
              name="usua_login"
              label="Login"
              variant="outlined"
              fullWidth
              size="small"
              disabled={!create}
            />
          }


          <Input
            name="usua_nome"
            label="Nome"
            variant="outlined"
            fullWidth
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Input
            name="usua_cpf"
            label="CPF"
            variant="outlined"
            fullWidth
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Input
            name="usua_senha"
            label="Senha"
            variant="outlined"
            fullWidth
            type="password"
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Checkbox
            name="usua_parametro1"
            label="Libera Aferição"
            checked={snLA}
            getValue={(value) => setSnLA(value)}
          />

          <Checkbox
            name="usua_parametro2"
            label="Recebe Combustível"
            checked={snRC}
            getValue={(value) => setSnRC(value)}
          />

          <Checkbox
            name="usua_parametro3"
            label="Opera Turno"
            checked={snOT}
            getValue={(value) => setSnOT(value)}
          />

          <RadioGroup
            name="usua_parametro5"
            label="Modo Operacional"
            options={[
              {
                label: 'Não libera',
                value: '0',
              },
              {
                label: 'Libera troca para o modo manual intermitente',
                value: '1',
              },
              {
                label: 'Libera troca para o modo manual constante',
                value: '2',
              },
            ]}
            serialize={(value) => String(value)}
            disabled={isGPP || isGFE || isGPPE || isGPPEM}
          //defaultValue={'0'}
          />

          <RadioGroup
            name="usua_parametro7"
            label="Libera Abastecimento"
            options={[
              {
                label: 'Não libera abastecimento',
                value: '0',
              },
              {
                label: 'Libera abastecimento com transponder cadastrado',
                value: '1',
              },
              {
                label: 'Libera abastecimento com transponder não cadastrado',
                value: '2',
              },
              {
                label: 'Libera abastecimento sem transponder',
                value: '3',
              },
            ]}
            serialize={(value) => String(value)}
            disabled={isGPP || isGFE || isGPPE || isGPPEM}
          //defaultValue={'0'}
          />

          <Select
            name="usua_status"
            variant="outlined"
            label="Status"
            options={[
              { value: 1, label: 'Liberado' },
              { value: 2, label: 'Bloqueado' },
              { value: 3, label: 'Cancelado' },
            ]}
          />

          {!isGPP && (
            <>
              <Autocomplete
                name="poco_codigo"
                label="poco_desc_abrev"
                title="Posto operação estoque"
                id="poco_codigo"
                url="postoscomboios"
                unique="poco_codigo"
                value={valuePosto}
                inputValue={inputValuePosto}
                onChange={(event, newValue) => {
                  setValuePosto(newValue);
                }}
                onInputChange={(event, newInputValuePosto) => {
                  setInputValuePosto(newInputValuePosto);
                }}
                defaultValue=""
                hiddens={[{ name: 'poco_desc_abrev' }]}
                getValue={(value) => {
                  if (value.poco_codigo !== null) {
                    setValuePosto(value.poco_codigo);
                  } else {
                    //setValuePosto(0);
                    setValuePosto(null);
                  }
                }}
              />

              {(!isGFE && !isGPPE && !isGPPEM) && (
                <>
                  <div>
                    <Typography variant="caption" gutterBottom>
                      Postos de acesso deste frentista
                    </Typography>
                    <Grid
                      container
                      spacing={2}
                      justify="center"
                      alignItems="center"
                      className={classes.root}
                    >
                      <Grid item>{customList(left)}</Grid>
                      <Grid item>
                        <Grid container direction="column" alignItems="center">
                          <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={handleAllRight}
                            disabled={left.length === 0}
                            aria-label="movimenta todos para a direita"
                          >
                            ≫
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={handleCheckedRight}
                            disabled={leftChecked.length === 0}
                            aria-label="movimenta os selecionados para a direita"
                          >
                            &gt;
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={handleCheckedLeft}
                            disabled={rightChecked.length === 0}
                            aria-label="movimenta os selecionados para a esquerda"
                          >
                            &lt;
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            className={classes.button}
                            onClick={handleAllLeft}
                            disabled={right.length === 0}
                            aria-label="movimenta todos para a esquerda"
                          >
                            ≪
                          </Button>
                        </Grid>
                      </Grid>
                      <Grid item>{customList(right)}</Grid>
                    </Grid>
                  </div>


                </>
              )}




            </>
          )}
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
